// Competências oferecidas no diálogo de análise mensal com IA.
//
// A união é a mesma que o eixo do gráfico usa (FinancialBarChart.jsx), com a
// mesma ordenação (ano, depois mês). As séries já chegam recortadas pelo
// PERIODO no backend, então o resultado respeita o filtro de data sem precisar
// olhar para `filterDates`.

const BAR_DATE = /^(0[1-9]|1[0-2])\/(\d{4})$/;
const FOLLOW_UP_DATE = /^(\d{4})-(\d{1,2})$/;

const fromBarDate = (value) => {
  const match = BAR_DATE.exec(String(value ?? ""));
  return match ? `${match[2]}-${match[1]}` : null;
};

const fromFollowUpDate = (value) => {
  const match = FOLLOW_UP_DATE.exec(String(value ?? ""));
  if (!match) return null;
  const month = match[2].padStart(2, "0");
  return month >= "01" && month <= "12" ? `${match[1]}-${month}` : null;
};

const hasValue = (point) => Number.isFinite(Number(point?.value)) && Number(point.value) !== 0;

const collect = (series, toCompetence, into) => {
  if (!Array.isArray(series)) return;
  series.forEach((point) => {
    if (!hasValue(point)) return;
    const competence = toCompetence(point?.date);
    if (competence) into.add(competence);
  });
};

export const availableCompetences = (project) => {
  const competences = new Set();

  [project?.paidValues, project?.disbursements, project?.toPayValues, project?.physicals]
    .forEach((series) => collect(series, fromBarDate, competences));

  // followUps carregam a medição do mês em `measuredDeltaValue`, não em `value`.
  if (Array.isArray(project?.followUps)) {
    project.followUps.forEach((point) => {
      const competence = fromFollowUpDate(point?.date);
      if (competence && Number(point?.measuredDeltaValue) !== 0) competences.add(competence);
    });
  }

  return Array.from(competences).sort();
};

export default availableCompetences;
